module.exports = __webpack_public_path__ + "static/media/billingLogo.e06481d7.svg";